(function () {
  function setup(gallery) {
    const thumbList = gallery.querySelector('.thumbnail-list');
    if (!thumbList) return;
    const mainSlider = gallery.querySelector('slider-component.slider-mobile-gutter');
    if (!mainSlider) return;
    const prev = mainSlider.querySelector('.slider-button--prev');
    const next = mainSlider.querySelector('.slider-button--next');
    if (!prev || !next) return;

    function thumbs() {
      return Array.from(thumbList.querySelectorAll('button.thumbnail, .thumbnail'))
        .filter(function (btn) {
          const li = btn.closest('li');
          if (!li) return true;
          if (li.classList.contains('bif-hide-media')) return false;
          if (li.classList.contains('hide-media')) return false;
          const cs = window.getComputedStyle(li);
          return cs.display !== 'none' && cs.visibility !== 'hidden';
        });
    }

    function activeIndex(list) {
      const i = list.findIndex((b) => b.getAttribute('aria-current') === 'true');
      return i >= 0 ? i : 0;
    }

    function go(delta) {
      const list = thumbs();
      if (!list.length) return;
      const idx = activeIndex(list);
      const nextIdx = (idx + delta + list.length) % list.length;
      const target = list[nextIdx];
      if (target) target.click();
    }

    prev.removeAttribute('disabled');
    next.removeAttribute('disabled');
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(-1);
    }, true);
    next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      go(1);
    }, true);
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
